import React, { useEffect, useState } from 'react';
import useAuthGuard from '../hooks/useAuthGuard';
import Layout from '../components/Layout';
import { API_BASE_URL } from '../config';
import apiFetch from '../utils/apiFetch';

function Dashboard() {
  useAuthGuard();

  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fmt = (n) => new Intl.NumberFormat().format(n ?? 0);

  useEffect(() => {
    const ac = new AbortController();
    (async () => {
      try {
        setLoading(true);
        setError('');
        const res = await apiFetch(`${API_BASE_URL}/admin/stats`, {
          signal: ac.signal,
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        setStats(data.data || data);
      } catch (e) {
        if (e.name !== 'AbortError') setError(e.message || 'Network error');
      } finally {
        setLoading(false);
      }
    })();
    return () => ac.abort();
  }, []);

  const cards = [
    { label: 'Total Users', key: 'total_users', icon: 'users', color: 'primary' },
    { label: 'Total Stores', key: 'total_stores', icon: 'map-pin', color: 'success' },
    { label: 'Total Posts', key: 'total_posts', icon: 'file-text', color: 'info' },
    { label: 'Total Reviews', key: 'total_reviews', icon: 'star', color: 'warning' },
    { label: "Today's New Users", key: 'today_new_users', icon: 'user-plus', color: 'secondary' },
    { label: "Today's New Posts", key: 'today_new_posts', icon: 'edit', color: 'dark' },
  ];

  return (
    <Layout>
      <div className="mb-4">
        <h2 className="mb-1">Dashboard</h2>
        <p className="text-muted mb-0">System overview and statistics</p>
      </div>

      {loading && (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}

      {!loading && !error && stats && (
        <div className="row g-4">
          {cards.map((card) => (
            <div key={card.key} className="col-12 col-md-6 col-xl-4">
              <div className="card shadow-sm border-0 h-100">
                <div className="card-body d-flex align-items-center gap-3">
                  <div
                    className={`d-flex align-items-center justify-content-center rounded bg-${card.color} bg-opacity-10`}
                    style={{ width: 48, height: 48 }}
                  >
                    <i
                      data-feather={card.icon}
                      className={`text-${card.color}`}
                      style={{ width: 24, height: 24 }}
                    ></i>
                  </div>
                  <div>
                    <h3 className="mb-0">{fmt(stats[card.key])}</h3>
                    <small className="text-muted">{card.label}</small>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </Layout>
  );
}

export default Dashboard;
